import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEslintComponent } from './simple-icons-eslint.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEslintComponent ],
    exports:      [ SimpleIconsEslintComponent ],
    bootstrap:    []
})
export class SimpleIconsEslintModule {}
